<template>

<div>
  <ValidationObserver ref="observer">
    <div class="card-title h5">1. {{ $t('tabs.personal_data.title') }}</div>
    <hr>
    <div class="row">
        <div class="col-md-4 col-sm-12">
          <!-- NOM -->
          <ValidationProvider rules="required" name="name">
            <label class="form-label required">{{ $t('tabs.personal_data.name') }}:</label>
            <input type="text" class="form-control" :class="{'input': true, 'is-invalid': errors.has('name') }"
                   name="name"
                   v-model="name"
                   v-validate="'required'"
            >
            <span v-show="errors.has('name')" class="invalid-feedback" >{{ errors.first('name') }}</span>
          </ValidationProvider>
        </div>
        <div class="col-md-4 col-sm-12">
          <!-- PRIMER COGNOM -->
          <ValidationProvider rules="required" name="surname1">
            <label class="form-label required">{{ $t('tabs.personal_data.surname1') }}:</label>
            <input type="text" class="form-control" :class="{'input': true, 'is-invalid': errors.has('surname1') }"
                   name="surname1"
                   v-model="surname1"
                   v-validate="'required'"
            >
            <span v-show="errors.has('surname1')" class="invalid-feedback" >{{ errors.first('surname1') }}</span>
          </ValidationProvider>
        </div>
        <div class="col-md-4 col-sm-12">
          <!-- SEGON COGNOM -->
          <label class="form-label">{{ $t('tabs.personal_data.surname2') }}</label>
          <input type="text" class="form-control" name="surname2" v-model="surname2" >
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 col-sm-12">
          <!-- DNI -->
          <ValidationProvider rules="required" name="dni">
            <label class="form-label required">{{ $t('tabs.personal_data.dni') }}:</label>
            <div class="input-group">
              <span class="input-group-text"><i class="fa fa-address-card"></i></span>
              <input type="text" class="form-control" :class="{'input': true, 'is-invalid': errors.has('dni') }"
                     name="dni"
                     v-model="dni"
                     v-validate="'required'"
                     v-on:keyup="validateDni"
                     placeholder="Ex. 12345678A"
              >
              <span v-show="errors.has('dni')" class="invalid-feedback">{{ errors.first('dni') }}</span>
              <span v-show="dni !== '' && errorNif" class="my-invalid-feedback">Format o DNI incorrecte</span>
            </div>
          </ValidationProvider>
        </div>
        <!-- GENERE -->
        <div class="col-md-6 col-sm-12">
          <label class="form-label required">{{ $t('tabs.personal_data.gender') }}</label>
          <select class="form-select" :class="{'input': true, 'is-invalid': errors.has('gender_id') }"
                  v-model="gender_id"
                  name="gender_id"
                  v-validate="'required'"
          >
            <option></option>
            <option v-for="(item, idx) in optionsGeneres" :value="item.id" :key="idx">{{ item.name}}</option>
          </select>
          <span class="invalid-feedback" v-show="errors.has('gender_id')">{{ errors.first('gender_id') }}</span>
        </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12">
        <!-- EMAIL -->
        <ValidationProvider rules="required" name="email">
          <label class="form-label required">{{ $t('tabs.personal_data.email') }}:</label>
          <div class="input-group">
            <span class="input-group-text"><i class="fa fa-at"></i></span>
            <input type="email" class="form-control" :class="{'input': true, 'is-invalid': errors.has('email') }"
                   name="email"
                   v-model="email"
                   v-validate="'required|email'"
                   placeholder="Ex. mymail@gmail.com"
            >
            <span v-show="errors.has('email')" class="invalid-feedback" >{{ errors.first('email') }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>


    <div class="row">
         <div class="col-md-12 col-sm-12">
           <!-- DATA NAIXAMENT -->
           <ValidationProvider rules="required" name="birthday">
             <label class="form-label required">{{ $t('tabs.personal_data.birthday') }}:</label>
             <div class="input-group">
               <span class="input-group-text"><i class="fa fa-birthday-cake"></i></span>
               <input type="text" class="form-control" :class="{'input': true, 'is-invalid': errors.has('birthday') }"
                      name="birthday"
                      v-model="birthday"
                      v-validate="'required|date_format:dd/MM/yyyy'"
                      placeholder="Ex. 13/08/1996"
               >
               <span v-show="errors.has('birthday')" class="invalid-feedback" >{{ errors.first('birthday') }}</span>
             </div>
           </ValidationProvider>
        </div>
    </div>

    <div class="row">
        <!-- GRAU CURSA -->
        <div class="col-md-12 col-sm-12">
            <div class="form-group">
                <label class="form-label required">{{ $t('tabs.personal_data.grade') }}:</label>
                <select class="form-select" :class="{'input': true, 'is-invalid': errors.has('study_id') }"
                        v-model="study_id"
                        name="study_id"
                        v-validate="'required'"
                        data-placeholder="Selecciona un grau"
                >
                    <option></option>
                    <option v-for="(estudi, id) in studies" :value="estudi.codi" :key="id">{{ estudi.name}}</option>
                </select>
                <span class="invalid-feedback" v-show="errors.has('study_id')">{{ errors.first('study_id') }}</span>
            </div>
        </div>
    </div>

    <div class="row">
      <!-- PROVINCIA RESIDENCIA -->
        <div class="col-md-12 col-sm-12">
            <label class="required form-label">{{ $t('tabs.personal_data.provincia') }}:</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-city"></i> </span>
                </div>
                <select class="form-select" :class="{'input': true, 'is-invalid': errors.has('provincia_residencia') }"
                        v-model="provincia_residencia"
                        name="provincia_residencia"
                        v-validate="'required'"
                        @change="onSelectProvincia($event)"
                        data-placeholder="Selecciona una provincia"
                >
                  <option v-for="(item, id) in provincias" :value="item.provincia_id" :key="id">{{ item.provincia }}</option>
                </select>
                <span class="invalid-feedback" v-show="errors.has('provincia_residencia')">{{ errors.first('provincia_residencia') }}</span>
            </div>
        </div>
      <!-- MUNICIPI RESIDENCIA -->
        <div class="col-md-12 col-sm-12" v-if="municipios.length > 0">
            <label class="required form-label">{{ $t('tabs.personal_data.population') }}:</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-city"></i> </span>
                </div>
                <select class="form-select" :class="{'input': true, 'is-invalid': errors.has('municipi_residencia') }"
                        v-model="municipi_residencia"
                        name="municipi_residencia"
                        v-validate="'required'"
                        @change="onSelectMunicipi($event)"
                        data-placeholder="Selecciona un municipi"
                >
                  <option v-for="(item, id) in municipios" :value="item.poblacion_id" :key="id">{{ item.poblacion }}</option>
                </select>
                <span class="invalid-feedback" v-show="errors.has('municipi_residencia')">{{ errors.first('municipi_residencia') }}</span>
            </div>
        </div>
    </div>

    <div class="row">
      <!-- ALLOTJAMENT -->
        <div class="col-sm-12 form-group">
            <label class=" form-label">{{ $t('tabs.personal_data.question1') }}:</label>
            <div class="form-check" v-for="(residencia, index) in optionsResidencesTypes" :key="index">
              <input type="radio" class="form-check-input"
                     name="residence_type"
                     v-model="residence_type"
                     :value="residencia.id"
              >
              <label class="form-check-label">{{ residencia[lang] }}</label>
            </div>
        </div>
    </div>

    <div class="row">
      <!-- COMPAGINAR ESTUDIS -->
      <div class="col-sm-6">
        <validation-provider rules="required" name="compaginar_estudis">
          <label class="required form-label">{{ $t('tabs.personal_data.question2_1') }}</label>
          <div class="form-check" v-for="(compaginar, index) in optionsCompaginarEstudis" :key="index">
            <input type="radio" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('compaginar_estudis') }"
                   name="compaginar_estudis"
                   v-model="compaginar_estudis"
                   v-validate="'required|included:' + optionsCompaginarEstudis.map(item => item.value)"
                   :value="compaginar.value"
            >
            <label class="form-check-label">{{ compaginar[lang] }}</label>
          </div>
          <span class="my-invalid-feedback" v-show="errors.has('compaginar_estudis')">{{ errors.first('compaginar_estudis') }}</span>
        </validation-provider>
      </div>
    </div>

    <!-- Si, COMPAGINA ESTUDIS -->
    <div class="form-group mb-3" v-show="compaginar_estudis === '1'">
      <validation-provider name="si_compaginar_estudis">
        <label class="form-label">{{ $t('tabs.personal_data.question2_2') }}:</label>
        <div class="form-check" v-for="(si_compaginar, index) in optionsSiCompaginarEstudis" :key="index">
          <input type="radio" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('si_compaginar_estudis') }"
                 name="si_compaginar_estudis"
                 v-validate="ruleSiCompaginarEstudis"
                 v-model="si_compaginar_estudis"
                 :value="si_compaginar.value"
          >
          <label class="form-check-label">{{ si_compaginar[lang] }}</label>
        </div>
        <span class="invalid-feedback" v-show="errors.has('si_compaginar_estudis')">{{ errors.first('si_compaginar_estudis') }}</span>
      </validation-provider>
    </div>
  </ValidationObserver>
</div>

</template>

<script>
import config from "@/config";
import checkDni from "@/helpers/validateNIF";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {list_tipus_residencia, list_compaginar_estudis, list_si_compaginar_estudis} from "@/helpers/data";

export default {
  name: 'dades-personals',
  props: { lang: { required:true, default:'ca'} },
  components: {ValidationObserver, ValidationProvider },
  data() {
    return {
      name: '',
      surname1: '',
      surname2: '',
      dni: '',
      birthday: '',
      gender_id: '',
      email: '',
      study_id: '',
      provincia_residencia: '',
      municipi_residencia: '',
      comarca_residencia: '',
      residence_type: '',
      compaginar_estudis: '',
      si_compaginar_estudis: '',
      optionsGeneres: [],
      optionsResidencesTypes: list_tipus_residencia,
      optionsCompaginarEstudis: list_compaginar_estudis,
      optionsSiCompaginarEstudis: list_si_compaginar_estudis,
      studies: [],
      residences: [],
      locations: [],
      provincias: [],
      municipios: [],
      errorNif: false
    }
  },
  created() {
    this.getStudies();
    this.getGeneres();
    this.getLocations();
    this.$validator.localize(this.lang);
    this.$i18n.locale = this.lang;
  },
  computed: {
    ruleSiCompaginarEstudis() {
      return this.compaginar_estudis && this.compaginar_estudis === '1' ? 'required|included:' + this.optionsSiCompaginarEstudis.map(item => item.value) : '';
    },
    getNom() {
      return this.name + ' ' + this.surname1 + ' ' + this.surname2;
    },
    getStudy() {
      return this.study_id ? this.studies.find(item => item.codi === this.study_id).name : '';
    }
  },
  methods: {
    async validate() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return false;
      }
      this.dni = this.dni.toUpperCase();
      this.$emit('on-validate', this.$data, true);
      this.$root.$emit('get-nom', this.getNom);
      this.$root.$emit('get-estudi', this.getStudy);
      return result;

    },
    validateDni(){
      this.errorNif = !checkDni.validate(this.dni) && !checkDni.isPassport(this.dni) && !checkDni.isNIE(this.dni);
    },
    getStudies(){
      this.axios.get(process.env.VUE_APP_LEINES_HOST+'survey/studies-graus/UPF', config.headers_api)
        .then(response => {
          this.studies = response.data;
        })
          .catch(error => { console.error(error); });
    },
    getResidences(){
      this.axios.get(process.env.VUE_APP_LEINES_HOST+'survey/residences', config.headers_api)
          .then(response => {
            this.residences = response.data;
          })
          .catch(error => { console.error(error); });
    },
    getGeneres(){
      this.axios.get(process.env.VUE_APP_LEINES_HOST+'survey/genders', config.headers_api)
          .then(response => {
            this.optionsGeneres = response.data;
          })
          .catch(error => { console.error(error); });
    },
    getLocations(){
      this.axios.get(process.env.VUE_APP_LEINES_HOST+'survey/locations', config.headers_api)
          .then((response) => {
            this.locations = response.data;
            this.loadProvincias();
          })
          .catch(error => { console.error(error); });
    },
    loadProvincias(){
      this.provincias = [...new Map(this.locations.map(item => [item.provincia_id, item])).values()].sort((a,b) => (a.provincia < b.provincia) ? -1 : (a.provincia > b.provincia) ? 1 : 0);
    },
    loadMunicipios(provinciaId) {
      this.municipios = [...new Map(this.locations.map(item => [item.poblacion_id, item])).values()].filter(item => item.provincia_id === provinciaId).sort((a,b) => (a.poblacion < b.poblacion) ? -1 : (a.poblacion > b.poblacion) ? 1 : 0);
    },
    loadComarca(poblacioId) {
      if (poblacioId === '') return;
      this.comarca_residencia = this.locations.find(item => item.poblacion_id === poblacioId).comarca_id || '';
    },
    onSelectProvincia(event) {
      this.municipi_residencia = '';
      this.loadMunicipios(event.target.value);
    },
    onSelectMunicipi(event) {
      this.comarca_residencia = '';
      this.loadComarca(event.target.value);
    }
  }
}
</script>